module.exports = __webpack_public_path__ + "img/31c2498.png";